module.exports = global["$"] = require("-!./jquery.js");


//////////////////
// WEBPACK FOOTER
// /root/social-native/socialnative-web/node_modules/expose-loader?$!/root/social-native/socialnative-web/node_modules/jquery/dist/jquery.js
// module id = 2018
// module chunks = 69